import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OfertaCredito } from 'src/app/models/oferta-credito.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-ofertas-credito',
  templateUrl: './ofertas-credito.component.html',
  styleUrls: ['./ofertas-credito.component.css']
})
export class OfertasCreditoComponent implements OnInit {
  ofertas: OfertaCredito[] = [];
  solicitudCreditoId!: string;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.solicitudCreditoId = this.route.snapshot.paramMap.get('solicitudId')!;
    this.loadOfertas();
  }

  loadOfertas(): void {
    this.dataService.getData('solicitud-credito/' + this.solicitudCreditoId + '/ofertas').subscribe({
      next: (data: OfertaCredito[]) => {
        this.ofertas = data;
      },
      error: (error: string) => {
        console.error('Error al cargar las ofertas', error);
      },
      complete: () => {
        console.log('Carga de ofertas completada');
      }
    });
  }
}